(function($){
    var $payment = $('.payment-selector input[type="radio"]');
    var $iban = $('.iban-input');

    $payment.change(function() {
        if ($(this).val() === 'direct.debit') {
            $iban.val('ES0000000000000000000000');
            $iban.attr('required', 'required');
            $iban.parent().slideDown();
        } else {
            $('.iban-input').removeAttr('required');
            $iban.parent().slideUp();
        }
    });

    if ($('.payment-selector input[type="radio"]:checked').val() != 'direct.debit') {
        $('.iban-input').removeAttr('required');
        $iban.parent().slideUp();
    }

}(window.jQuery));
